import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';
import { GetUserBoughtExamsModel } from 'src/app/shared/api-models/responses/exam/GetUserBoughtExamsModel';
import { GetUserNotBoughtExamsModel } from 'src/app/shared/api-models/responses/exam/GetUserNotBoughtExamsModel';
import { GetUserAllExamsRequestModel } from 'src/app/shared/api-models/requests/exam/GetUserAllExamsRequestModel';

/**
 * گرفتن   همه آزمون های یوزر
 */

export interface userAllExamsREsponseModel {
  count_al: number
  items: []
}
@Injectable({
  providedIn: 'root'
})
export class GetUserAllExamsService {
  constructor(private baseClient: BaseHttpClientService) { }

  call(body: GetUserAllExamsRequestModel) {
    const res = this.baseClient.postWithAuth<userAllExamsREsponseModel>(
      `/api/v1/exam/get_user_all_exams`, body
    );

    return res;
  }
}
